import * as fromLoading from '../../actions/shared/mainLoad.action';

export interface LoadState {
  Activo: boolean;
}

export const initialState: LoadState = {
    Activo: false
};

export function loadReducer(state = initialState, action: fromLoading.MainLoadAcciones): LoadState {
    switch (action.type) {
      case fromLoading.MainLoadActionTypes.ACTIVE_MAIN_LOAD: {
        return {
          ...state,
          Activo: true
        };
      }
      case fromLoading.MainLoadActionTypes.DEACTIVE_MAIN_LOAD: {
        return {
          ...state,
          Activo: false
        };
      }
      default: {
        return state;
      }
    }
  }